
<form id="myForm" (ngSubmit)="onSubmit()" [formGroup]="form" class="vertical-form">
  <div fxLayout="column" fxFlexFill fxLayoutGap="20px">

    <div fxFlex="1 1 100%" fxLayout="row" fxFlexFill fxLayoutGap="20px">

      <div fxFlex="40%" fxLayout="column" fxLayoutAlign="start" fxLayoutGap="20px">

        <div class="box" fxFlex fxLayout="column" fxLayoutAlign="start">
          <h5>Chance settings</h5>
          <div fxFlexLayout="row" fxLayoutAlign="space-between" fxLayoutGap="20px">
            <mat-form-field fxFlex>
              <mat-label>Score per chance</mat-label>
              <input matInput type="number" placeholder="" formControlName="scorePerChance">
              @if (!form.get('scorePerChance').valid) {
                <mat-error>Enter a valid score per chance</mat-error>
              }
            </mat-form-field>
            <mat-form-field fxFlex style="min-width: 100px;">
              <mat-label>Initial chance count</mat-label>
              <input matInput type="number" placeholder="" formControlName="initialChanceCount">
              @if (!form.get('initialChanceCount').valid) {
                <mat-error>Enter initial chance count </mat-error>
              }
            </mat-form-field>
          </div>
          <div fxFlexLayout="row" fxLayoutAlign="space-between" fxLayoutGap="20px">
            <mat-form-field fxFlex style="min-width: 100px;">
              <mat-label>Max chances per consumption event</mat-label>
              <input matInput placeholder="" formControlName="maxChancesPerConsumptionEvent" maxlength="100">
              @if (!form.get('maxChancesPerConsumptionEvent').valid) {
                <mat-error>Enter max chances per consumption event</mat-error>
              }
            </mat-form-field>
            <mat-form-field fxFlex style="min-width: 100px;">
              <mat-label>Seconds between chances</mat-label>
              <input matInput type="number" placeholder="" formControlName="secondsBetweenChances">
              @if (!form.get('secondsBetweenChances').valid) {
                <mat-error>Enter seconds between two chances </mat-error>
              }
            </mat-form-field>
          </div>
          <mat-form-field>
            <mat-label>Game product</mat-label>
            <mat-select placeholder="" formControlName="gameSlug">
              <mat-option [value]="null"></mat-option>
              @for (gameProduct of gameRewardProductsOptions; track gameProduct) {
                <mat-option [value]="gameProduct.productSlug" [matTooltip]="gameProduct.productSlug">{{ gameProduct.rewardTitle }}</mat-option>
              }
            </mat-select>
            <!-- <input matInput placeholder="Game URL" formControlName="gameUrl" maxlength="100"> -->
            @if (!form.get('gameSlug').valid) {
              <mat-error>Please select a game product</mat-error>
            }
          </mat-form-field>
        </div>

        <div class="box" fxFlex fxLayout="column" fxLayoutAlign="start">
          <app-receipt-check-options-edit [formControl]="form.controls.receiptCheck"></app-receipt-check-options-edit>
        </div>

      </div>

      <div fxFlex>
        <app-consumption-filters-edit #filters></app-consumption-filters-edit>
      </div>

    </div>

    <app-reward-chances-select #rewardChances [advertiserId]="advertiserId"></app-reward-chances-select>
    <app-reward-select #joinReward [advertiserId]="advertiserId" [title]="'Join instant win'"></app-reward-select>
    <app-reward-select #firstConsumptionReward [advertiserId]="advertiserId" [title]="'First consumption instant win'"></app-reward-select>
    <app-reward-select #consumptionReward [advertiserId]="advertiserId" [title]="'Any consumption instant win'"></app-reward-select>
  </div>
</form>